import { render, staticRenderFns } from "./background.vue?vue&type=template&id=5ee36cdf&scoped=true&"
var script = {}
import style0 from "./background.vue?vue&type=style&index=0&id=5ee36cdf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee36cdf",
  null
  
)

export default component.exports